import { z } from 'zod';

const DigitSegmentSchema = z
  .object({
    type: z.literal('digits'),
    min: z.number().int().positive(),
    max: z.number().int().positive(),
  })
  .strict();

const LetterSegmentSchema = z
  .object({
    type: z.literal('letters'),
    min: z.number().int().positive(),
    max: z.number().int().positive(),
  })
  .strict();

const LiteralSegmentSchema = z
  .object({
    type: z.literal('literal'),
    value: z.string().min(1),
  })
  .strict();

export const SegmentSchema = z.discriminatedUnion('type', [
  DigitSegmentSchema,
  LetterSegmentSchema,
  LiteralSegmentSchema,
]);
export type Segment = z.infer<typeof SegmentSchema>;

export const StructuredIdentifierConfigSchema = z
  .object({
    inquiryPhrases: z.array(z.string().min(1)).min(1),
    segments: z.array(SegmentSchema).min(1),
  })
  .strict();
export type StructuredIdentifierConfig = z.infer<
  typeof StructuredIdentifierConfigSchema
>;
